/**
 * Today's date as `YYYY-MM-DD`, in the editor's own timezone.
 *
 * Both content collections store dates as ISO date strings (`z.iso.date()` in
 * `packages/shared/cms/schema.ts`) and format them with string surgery at
 * render, so this must produce the same shape.
 *
 * **Built from local components, not `toISOString()`.** That method formats in
 * UTC, and the editors are in UTC+8/+9 — so for the first eight or nine hours
 * of every working day it would prefill *yesterday*. This is the mirror image
 * of the bug AGENTS.md warns about on the render side, where `new Date(iso)`
 * parses a date-only string as UTC midnight and displays the previous day west
 * of Greenwich. Same trap, opposite hemisphere.
 *
 * Called at module scope by the collection definitions, so the value is fixed
 * when the SPA loads rather than per form open. A session left open across
 * midnight prefills the previous day; the field is editable and required, so
 * that is a stale default rather than a wrong record.
 */
export function todayIso(date: Date = new Date()): string {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
}
